import './BinaryBreakout.css';
import { Link } from 'react-router-dom'
import { useTheme } from '../../hooks/useTheme'


function BinaryBreakout() {
  const { mode } = useTheme()

  return (
    <div className={`scratch-game ${mode}`}>
         <div className='breadcrumbs'>
          <Link to="/">
              <div className='link-crumb'>/Home </div>
          </Link>
          <Link to="/games">
              <div className='link-crumb'> /Games </div>
          </Link>
          <div className='link-crumb'> /Binary Breakout</div>
      </div>
      <h1>Binary Breakout</h1>
      <p>Teammate Kadiesha, summer 2024</p>
      <a href='https://scratch.mit.edu/projects/1037961005/' target="_blank" rel="noreferrer">View on Scratch site</a>
      <div className='game-container'>
        <a href='https://scratch.mit.edu/projects/1037961005/' target="_blank" rel="noreferrer">
            <img src='https://i.imgur.com/EoK3aoR.png' alt='game screenshot'/>
        </a>
      </div>
      <Link to="/games">
         <div className='link'>&#8592; Back to all Games</div>
       </Link>
    </div>
  );
}

export default BinaryBreakout;